export const socialMediaLinks = {
    facebook: 'https://www.facebook.com/Boxyland-103417784816290',
    instagram: 'https://www.instagram.com/boxyland_europe/',
    youtube: 'https://www.youtube.com/channel/UCIrfhDhDrIbHujiK6u9Kx8Q',
    linkedin: 'https://www.linkedin.com/company/67758015'
}

export const appStores = {
    appStore: 'https://itunes.apple.com/app/id1539635120',
    googlePlay: 'https://play.google.com/store/apps/details?id=com.boxyland.app'
}

export const helpVideoSrc = 'https://www.youtube.com/watch?v=8CKsvuSjXC8'

export const franchisingVideoSrc = 'https://www.youtube.com/embed/2mMFXE-O3Ik'
